export const RESTAURANTS = [
  { id: "rst_shivaji_1", name: "Spice Route Kitchen", lat: 18.5309, lng: 73.8472, area: "Shivaji Nagar" },
  { id: "rst_camp_1", name: "Harvest Bowl Collective", lat: 18.5167, lng: 73.8656, area: "Camp" },
  { id: "rst_deccan_1", name: "Urban Tiffin Works", lat: 18.5188, lng: 73.8413, area: "Deccan" },
  { id: "rst_kothrud_1", name: "Lakeview Table", lat: 18.5057, lng: 73.8072, area: "Kothrud" },
  { id: "rst_kothrud_2", name: "Copper Plate Diner", lat: 18.5142, lng: 73.7961, area: "Kothrud" },
  { id: "rst_aundh_1", name: "Nourish Point", lat: 18.5571, lng: 73.8043, area: "Aundh" },
  { id: "rst_aundh_2", name: "Metro Meal Studio", lat: 18.5672, lng: 73.8158, area: "Aundh" },
  { id: "rst_viman_1", name: "Skyline Kitchen Hub", lat: 18.4478, lng: 73.8261, area: "Viman Nagar" },
  { id: "rst_viman_2", name: "Runway Food Lab", lat: 18.4523, lng: 73.8141, area: "Viman Nagar" },
  { id: "rst_pashan_1", name: "Green Fork Bistro", lat: 18.5435, lng: 73.7872, area: "Pashan" },
  { id: "rst_pashan_2", name: "Peak Meal Co.", lat: 18.5358, lng: 73.8012, area: "Pashan" },
  { id: "rst_baner_1", name: "Northline Canteen", lat: 18.5594, lng: 73.7769, area: "Baner" }
];
